import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import { categoryListQueryOptions } from '@/modules/category/category.hooks'

export const categoryRoute = createRoute({
  path: '/categories',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const categoryListRoute = createRoute({
  getParentRoute: () => categoryRoute,
  path: '/',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'category.list',
      'Kategori listesine erişim izniniz yok.'
    ),
  // Sayfalama yok — proxy düz liste döner; tablo içi arama client-side.
  loader: () => queryClient.ensureQueryData(categoryListQueryOptions()),
  head: () => ({ meta: [{ title: 'Kategoriler' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/category/pages/list-category.page')
  ),
})
